/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Directive, TemplateRef} from '@angular/core';
import {CdkStepLabel} from '@angular/cdk/stepper';
/**
 * Workaround for https://github.com/angular/angular/issues/17849
 */
export const _MdStepLabel = CdkStepLabel;
export class MdStepLabel extends _MdStepLabel {
/**
 * @param {?} template
 */
constructor(template: TemplateRef<any>) {
    super(template);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[mdStepLabel], [matStepLabel]',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TemplateRef, },
];
}

function MdStepLabel_tsickle_Closure_declarations() {
/** @type {?} */
MdStepLabel.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdStepLabel.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
